import { render } from "./Dashboard.vue?vue&type=template&id=4c4a6565"
import script from "./Dashboard.vue?vue&type=script&lang=js"
export * from "./Dashboard.vue?vue&type=script&lang=js"

import "./Dashboard.vue?vue&type=style&index=0&id=4c4a6565&lang=scss"

import exportComponent from "D:\\Projects\\Normann\\Configurator Dashboard\\normann-dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__